import { Icon, IconName } from "@blueprintjs/core"
import React from "react"

type Info = {
  title?: React.ReactNode
  className?: any
  icon?: IconName | SVGElement
  subtitle?: React.ReactNode
  subtitleClassName?: any
}
type TrackInfoType = {
  info: Info[]
}
const TrackInfo = ({ info }: TrackInfoType) => {
  return (
    <div>
      {info.map((item, index) => {
        return (
          <div key={index} className="mb-2 last:mb-0 flex items-start gap-2">
            {typeof item.icon === "string" ? (
              <Icon size={16} icon={item.icon} />
            ) : (
              item.icon
            )}{" "}
            <div>
              <h6 className="m-0">{item.title}</h6>
              {item.subtitle && (
                <p className="font-sm text-gray-600 m-0">{item.subtitle}</p>
              )}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default TrackInfo
